import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon, Popup } from 'semantic-ui-react'
import { calculateFileSize } from '../../core/utilities'

import { FileUploadCellContainer } from './styled'

const FileUploadCell = (props) => {
  const { 
    fileName, 
    fileSize, 
    onClickDelete, 
    fileType, 
    pendingDelete, 
    deletable, 
    style, 
    urlPath=null 
  } = props

  return (
    <Popup content={fileName} basic trigger={
      <FileUploadCellContainer 
        className='fileUploadCellContainer' 
        pendingDelete={pendingDelete}
        style={{
          ...style,
          cursor: urlPath ? 'pointer' : 'unset'
        }}
      >
        <div className='left' onClick={() => {urlPath&&window.open(urlPath)}}>
          <div className='iconContent'>
            <Button 
              icon 
              type='button'
              style={{ background: 'transparent' }} >
              <Icon style={{ fontSize: '1rem' }} name={ fileType.includes('pdf') ? 'file pdf' : ( fileType.includes('image') ? 'file image' : 'file')} />
            </Button>
          </div>
          <div className='fileNameContent'>{fileName}</div>
        </div>
        <div className='right'>
          <div className='fileSizeContent'>
            {calculateFileSize(fileSize)}
          </div>
          {deletable ?
            <Button 
              icon 
              type='button'
              style={{ background: 'transparent' }}
              onClick={onClickDelete} >
              <Icon style={{ fontSize: '1rem' }} name='trash' />
            </Button> 
            :
            <React.Fragment>
              {urlPath?
                <Button 
                  icon 
                  onClick={()=>{urlPath&&window.open(urlPath)}}
                  type='button'
                  style={{ background: 'transparent' }} >
                  <Icon style={{ fontSize: '1rem' }} name='download' />
                </Button>
                :
                <div style={{ width: '10px' }} />
              }
            </React.Fragment>
          }
        </div>
      </FileUploadCellContainer>
    }/>
  )
} 

FileUploadCell.propTypes = {
  fileName: PropTypes.string.isRequired,
  fileSize: PropTypes.number,
  fileType: PropTypes.string,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  onClickDelete: PropTypes.func,
  pendingDelete: PropTypes.bool,
  deletable: PropTypes.bool,
}

FileUploadCell.defaultProps = {
  fileSize: 0.0,
  fileType: '',
  onClick: () => {},
  loading: false,
  pendingDelete: false,
  deletable: true,
}

export default FileUploadCell